import htmlToDom from '../../helpers/htmlToDom';
import makeBazarOrderElement from './makeBazarOrderElement';

export default (value) =>
	htmlToDom(`
		<li class="order-history__item order-history__bazar">
			<p>Дата покупки: ${value['action_timestamp'].substr(0, 16)}</p>
			<p>Магазин: ${value['name']}</p>
			<div class="order-history__bazar-list-header">
				<p class="order-hitory__table-name">Наименование</p>
				<p class="order-hitory__table-count">Количество</p>
			</div>
			<ul>
				${value['items']
					.map(makeBazarOrderElement)
					.map((el) => el.outerHTML)
					.join('')}
			</ul>
			<p class="order-history__item-price">Цена: ${value['price'].split('.')[0].toLocaleString()} руб.</p>
			<p class="order-history__item-comment">Комментарий: ${value['comment'] ? value['comment'] : '-'}</p>
		</li>
	`);
